/* eslint-disable */
const asset = (file) => {
  const base = process.env.PUBLIC_URL || ''
  return `${base}/${file}`
}

let loadingScript = null

const loadScript = () => {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('只能在浏览器里加载清晰缩放'))
  }
  if (window.Vips) return Promise.resolve(window.Vips)
  if (loadingScript) return loadingScript
  const promise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = asset('vips.js')
    script.async = false
    script.onload = () => {
      if (window.Vips) resolve(window.Vips)
      else reject(new Error('vips.js 已加载但没有暴露 Vips'))
    }
    script.onerror = () => reject(new Error('vips.js 加载失败'))
    document.head.appendChild(script)
  })
  promise.catch(() => {
    if (loadingScript === promise) loadingScript = null
  })
  loadingScript = promise
  return promise
}

const loadVips = async () => {
  if (!window.crossOriginIsolated) {
    throw new Error(
      '浏览器没有开启跨域隔离，清晰缩放起不来。请重新启动前端开发服务后再刷新页面。',
    )
  }
  const Vips = await loadScript()
  return Vips({ dynamicLibraries: [] })
}

module.exports = loadVips
